import React from 'react';
import ParticleBackground from '../components/ParticleBackground';
import ScrollProgress from '../components/ScrollProgress';
import Hero from '../components/Hero';
import ProductDemo from '../components/ProductDemo';
import Features from '../components/Features';
import HorizontalScroll from '../components/HorizontalScroll';
import Showcase from '../components/Showcase';
import Certifications from '../components/Certifications';
import Impact from '../components/Impact';
import CTA from '../components/CTA';
import BlogSection from '../components/BlogSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <span id="top" />
      <ParticleBackground />
      <ScrollProgress />
      <Hero />
      <ProductDemo />
      <Features />
      <HorizontalScroll />
      <Showcase />
      <Certifications />
      <Impact />
      <div id="blog">
        <BlogSection />
      </div>
      <CTA />
      <Footer />
    </>
  );
};

export default Home;
